// Retry callbacks and abort controllers for export jobs, keyed by job id. Kept
// outside Redux because closures and AbortControllers aren't serializable state.
const retryHandlers = new Map();
const abortControllers = new Map();

export function registerExportRetry(jobId, retryFn) {
    retryHandlers.set(jobId, retryFn);
}

export function retryExportJob(jobId) {
    const retryFn = retryHandlers.get(jobId);
    if (retryFn) {
        retryFn();
    }
}

export function registerExportAbort(jobId, abortController) {
    abortControllers.set(jobId, abortController);
}

export function cancelExportJob(jobId) {
    const controller = abortControllers.get(jobId);
    if (controller) {
        controller.abort();
    }
}
